import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NewExpenseForm = ({ isOpen, onClose, selectedRowData }) => {
    const [title, setTitle] = useState('');
    const [amount, setAmount] = useState('');
    const [expenseDate, setExpenseDate] = useState('');

    const postData = async () => {
      if ( !title || !amount || !expenseDate) {
          console.log("EMPTY FIELD")
      }
      else {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/expenses/add_expense`, {
            "title": title,
            "amount": amount,
            "expensedate": expenseDate
        })
        if (response.status === 200) {
            toast.success(`Expense created successfully.`)
        }
        else
        {
            toast.error("Error creating expense")
        }
      }

    }


    const updateData = async () => {
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/expenses/edit_expense`, {
          id: selectedRowData.id,
          title: title,
          amount: amount,
          expensedate: expenseDate
      })
      if (response.status === 200) {
        toast.success(`Expense with id: "${selectedRowData.id}" updated successfully.`)
      }
      else{
        toast.error("Error updating expense")
      }
    }


    useEffect(() => {

      if (selectedRowData !== null) {

        if (selectedRowData) {
          // Assuming you have form fields like firstName, lastName, etc.
          setTitle(selectedRowData.title);
          setAmount(selectedRowData.amount);
          setExpenseDate(selectedRowData.expensedate);
        }
        else
        {
          setTitle('');
          setAmount('');
          setExpenseDate('');
        }
      }
    }, [selectedRowData]);


    const handleSubmit = (event) => {
        event.preventDefault();

        if (selectedRowData) {
            updateData()
        }
        else {
            postData()
        }
        setTitle('');
        setAmount('');
        setExpenseDate('');

        onClose();
    };

    return (
        <div style={{
            display: isOpen ? 'block' : 'none',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            backdropFilter: 'blur(5px)',
        }}>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <h2 className='text-2xl font-bold font-poppins ml-2 mt-3 mb-3'>{selectedRowData ? "Update expense" : "Add New Expense"}</h2>
            <form onSubmit={handleSubmit}>

                <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="Title"
                    onChange={(e) => setTitle(e.target.value)}
                    value={title}
                    fullWidth
                    required
                    sx={{ mb: 4 }}
                />

                <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="amount"
                    onChange={(e) => setAmount(e.target.value)}
                    value={amount}
                    fullWidth
                    required
                    sx={{ mb: 4 }}
                />

                <div className="flex flex-col">
                    <label htmlFor="expenseDate">Expense Date</label>
                    <input
                        type="date"
                        name="purchaseDate"
                        id="purchaseDate"
                        placeholder="Expense Date"
                        autoComplete="off"
                        value={expenseDate}
                        onChange={(e) => setExpenseDate(e.target.value)}
                    />
                </div>
                <button
                    type='submit'
                    className='w-[120px] text-white rounded font-bold font-poppins bg-[#007FFF] p-2 mr-5 mt-2 mb-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
                >
                    {selectedRowData ? "Update Expense" : "Add Expense"}
                </button>
            </form>
            <button
                onClick={onClose}
                className='w-[120px] text-red-500 border border-red-500 rounded font-bold font-poppins bg-white p-2 mr-5 mt-2 mb-2 hover:bg-red-500 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
            >
                Close
            </button>

        </div>
    );
};

export default NewExpenseForm;
